import Vue from 'vue'
import Vuex from 'vuex'

import { IuguCreditCard } from '../types/Iugu'

Vue.use(Vuex)

const card: IuguCreditCard = {
  first_name: '',
  last_name: '',
  number: '',
  expirationMonth: '',
  expirationYear: '',
  verification_value: '',
}

const getters = {
  ACAO: (state: any) => {
    return state.acao
  },
  CARD: (state: any) => {
    return state.card
  },
  LOADING: (state: any) => {
    return state.loading
  },
}

const actions = {}

const mutations = {
  ACAO (context: any, acao) {
    context.acao = acao
  },
  LOADING (context: any, loading) {
    context.loading = loading
  },
}

export default new Vuex.Store({
  state: {
    acao: '',
    card: card,
    loading: false,
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
})
